import StatusGif from "entities/status-gif";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { isDevelopmentEnvironment } from "shared/utils/checkEnvironment";
import { twMerge } from "tailwind-merge";
import StatusSupport from "widgets/status-support";

const Pending = () => {
  return (
    <div
      className={twMerge(
        isDevelopmentEnvironment() ? "gg-mx-auto" : "",
        "gg-max-w-3xl"
      )}
    >
      <div className="gg-mb-28 gg-text-center">
        <StatusGif
          src={`https://media1.giphy.com/media/Jlta2V1EwWxtJb8p2o/giphy.gif`}
          alt="Een GewoonGers Gif. Gerse medewerker die aan het wachten is."
        />

        <Heading headingLevel="h1" className="gg-mb-5 md:!gg-text-5xl">
          Je betaling is in behandeling
        </Heading>

        <Text className="gg-text-lg">
          Op dit moment is je betaling nog in behandeling. Zodra er iets
          veranderd in de status van je betaling, ontvang je een bericht van
          ons.
        </Text>
      </div>

      <StatusSupport />
    </div>
  );
};
export default Pending;
